import { React } from '../react.js';
import { Icon } from '../icons.js';
import { useAppState } from '../../app/app.context.js';

export function FeedbackToast() {
  const state = useAppState();
  if (!state.feedbackMessage) return null;
  return (
    <div className="feedback-toast" role="status" aria-live="polite">
      <Icon name="check" size={14}/><span>{state.feedbackMessage}</span>
    </div>
  );
}
